'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');

// Stores
const ItemStore = require('../../stores/ItemStore.es');

// Components
const ModalWrapper = require('react-modal-wrapper');
const DetailsReturnModal = require('./DetailsReturnModal');
require('react-modal-wrapper/dist/main.css');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const { trackGaEvent } = require('../../helpers/pdpTracking');
const get = require('lodash.get');

function _link({ href, text }) {
    return <a href={href}>{text}</a>;
}

_link.propTypes = {
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};

function onOpen({ item }) {
    return () => {
        const description = get(item, `returnPolicy.accept`, false) ? 'returns accepted' : 'returns not accepted';
        trackGaEvent(
            'product',
            'view return details',
            `pdp description|${description}`
        );
    };
}

function DetailsReturnLink({ itemId, href, text, item, user }) {
    const link = _link({ href, text });

    return (
        <ModalWrapper openByClickOn={link} closeOnEsc closeOnOutsideClick onOpen={onOpen({user, item})}>
            <DetailsReturnModal item={item} user={user} itemId={itemId} />
        </ModalWrapper>
    );
}

DetailsReturnLink.propTypes = {
    context: PropTypes.object,
    user: PropTypes.object,
    item: PropTypes.object,
    itemId: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};

module.exports = Relay.createContainer(provideContext(connectToStores(
    DetailsReturnLink,
    [
        ItemStore
    ],
    context => {
        const itemStore = context.getStore(ItemStore);
        return { itemId: itemStore.getFromSV('data.pk') };
    }
)), {
    fragments: {
        item: () => Relay.QL`
            fragment on Item {
                ${DetailsReturnModal.getFragment('item')}
                returnPolicy {
                    accept
                }
            }
        `,
        user: () => Relay.QL`
            fragment on User {
                ${DetailsReturnModal.getFragment('user')}
                canSeeTradeReturns: hasPermission(name: "B_TRADE_RETURN_POLICY")
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsReturnLink.jsx